<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="alias">
        <el-input v-model="queryParams.alias" placeholder="ICCID/代理商"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="title">
        <el-input v-model="queryParams.title" placeholder="抬头"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="status">
        <el-select v-model="queryParams.status" filterable placeholder="发票状态" @change="search" clearable multiple>
          <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-download" @click="handleExport" v-hasPermi="['personalOffice:invoiceTask:export']">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}" style="margin-top: 10px;">
      <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="alias" label="ICCID/代理商" align="center" width="180px" ></el-table-column>
      <el-table-column prop="createTime" label="申请时间" align="center"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
      <el-table-column prop="money" label="发票金额" align="center"></el-table-column>
      <el-table-column prop="titleType" label="抬头类型" align="center"></el-table-column>
      <el-table-column prop="type" label="发票类型" align="center"></el-table-column>
      <el-table-column prop="invoiceInformation" label="发票信息" align="center" width="300px">
        <template slot-scope="scope">
          <p class="invoiceInformation-p">抬头：{{scope.row.title}}</p>
          <p class="invoiceInformation-p">税号：{{scope.row.ein}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="发票状态" align="center">
        <template slot-scope="scope">
          <span class="status-yd lvse" v-if="scope.row.status == '已通过' || scope.row.status == '已寄出'"></span>
          <span class="status-yd huangse" v-else-if="scope.row.status == '审核中'"></span>
          <span class="status-yd hongse" v-else-if="scope.row.status == '未通过'"></span>
          {{scope.row.status}}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="审核备注" align="center" width="250px" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" width="250px">
        <template slot-scope="scope">
          <div v-if="scope.row.type == '增值税专用发票' &&　scope.row.status == '已寄出'">
            <p class="invoiceInformation-p">寄出时间：{{scope.row.updateTime}}</p>
            <p class="invoiceInformation-p">{{scope.row.courierName}}：{{scope.row.courierNum}}</p>
          </div>
          <div v-else>
            <p>-</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain icon="el-icon-coordinate" @click="handle(scope.row.processInstanceId,scope.row.taskId)" v-if="scope.row.isOperation =='1'" v-hasPermi="['personalOffice:myMission:transaction']">办理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { workflowInvoice } from "@/api/api.js";
import axios from "axios";
export default {
  name: "invoiceTask",
  data() {
    return{
      queryParams:{},
      operator:[
        { value: 2,label: "已通过"},
        { value: 3,label: "已开票"},
        { value: 4,label: "已寄出"},
      ],
      dateRange:[],
      an:false,
      tableData:[],
      value:"",
      page: 1,
      pageSize: 20,
      total:0,
    }
  },
  methods: {
    // 状态转换
    inventoryStatusType(status) {
      let obj = {
        0: "未通过",
        1: "审核中",
        2: "已通过",
        3: "已开票",
        4: "已寄出",
        5: "其他",
        6: "已驳回",
        7: "不开票",
      };
      return obj[status];
    },
    // 初始化数据
    initData(){
      let params = {
        model:{
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      workflowInvoice(params).then(res=>{
        if(res.data.code == 200){
          this.tableData = res.data.data.records;
          this.tableData.map((item,index)=>{
            item.ids = index + 1;
            item.type = item.type == 1 ? "电子普通发票" : "增值税专用发票";
            item.titleType = item.titleType == 1 ? "企业单位" : "个人/事业单位";
            item.status = this.inventoryStatusType(item.status);
            item.ein = item.ein == null ? "-" : item.ein;
          })
          this.total = res.data.data.total
        }
      })
    },
    handleExport(){
      let params = {
        ...this.queryParams
      }
      axios.request({
        url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API +'/invoice/invoiceExport',
        responseType: 'blob',
        method: 'post',
        data:params
      }).then(res => {
        let blob =new Blob([res.data], { type: 'application/vnd.ms-excel' });
        let url = window.URL.createObjectURL(blob);
        window.location = url;
      }), (error) => {
        this.$message({
          type: 'warning',
          message: '系统错误，请联系管理员!'
        });
      }
    },
    search(){
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    // 详情跳转
    handle(processId,id){
      this.$router.push( `/personalOffice/taskTransaction/`+processId+"/"+id);
    },
    // 下载发票
    editRow(url){
      window.open(url);   
    },
  },
  created() {
    this.initData();
  },
  mounted() {},
};
</script>
<style scoped lang="less">
  .invoiceInformation-p{
    text-align: left;
  }
  .lvse{
    background: #15C392;
  }
  .hongse{
    background: red;
  }
  .huangse{
    background: #E6A23C;
  }
  .status-yd{
    display:inline-block;
    position: relative;
    top: -1px;
    display: inline-block;
    width: 6px;
    height: 6px;
    vertical-align: middle;
    border-radius: 50%;
  }
</style>


